jQuery(function ($) {
    $('.two-col-grid').each(function () {
        const $grid = $(this);
        const $contents = $grid.find('.col .content');

        function alignContent() {
            $contents.css('min-height', '');

            const anyExpanded = $contents.filter('.is-expandable').not('.collapsed').length > 0;
            const shouldAlign = !anyExpanded && $contents.length > 1 && window.innerWidth > 600;

            $grid.toggleClass('is-aligned', shouldAlign);

            if (!shouldAlign) {
                return;
            }

            let tallest = 0;
            $contents.each(function () {
                tallest = Math.max(tallest, this.clientHeight);
            });

            if (tallest) {
                $contents.css('min-height', tallest + 'px');
            }
        }

        $grid.find('.col').each(function () {
            const $col = $(this);
            const $content = $col.find('.content');
            const $readMore = $col.find('.read-more');

            // Check if content is overflowing
            if ($content.length && $content[0].scrollHeight <= $content[0].clientHeight) {
                // Content fits within the clamp, hide read more button
                $readMore.addClass('hidden');
                $content.removeClass('collapsed');
            } else {
                // Content is overflowing, show read more button
                $content.addClass('is-expandable');
                $readMore.on('click', function () {
                    if ($content.hasClass('collapsed')) {
                        $content.removeClass('collapsed');
                        $(this).text('Read less');
                    } else {
                        $content.addClass('collapsed');
                        $(this).text('Read more');
                    }
                    alignContent();
                });
            }
        });

        alignContent();

        let resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(alignContent, 150);
        });
    });
});